<template>
  <b-row>
    <b-col cols="12">
      <team-add-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import TeamAddForm from './TeamAddForm.vue'

export default {
  components: {
    BRow,
    BCol,
    TeamAddForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
